import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { GroupIdLedgerPage } from './-group-id-ledger/-components/GroupIdLedgerPage';
import { GroupIdLedgerTableFilterSchema } from './-group-id-ledger/-zod-schema';
export const Route = createFileRoute('/_staff/ids/_layout/_placeholders/group-id')({
  validateSearch: zodValidator(GroupIdLedgerTableFilterSchema),
  component: GroupIdLedgerPage
});